import React, { useState } from 'react';

import Spinner from '../../components/Common/Spinner/Spinner';
import Layout from '../Layout';

import es from '../../lang/es';
import { Button, Col, Form, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faLocationArrow } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import messages from '../../constants/messages';
import { listHistoryAction } from '../../actions/proceedingActions';
import { removeProceedingAction } from '../../actions/authActions';
import alertMessages from '../../helpers/alertMessages';
import colors from '../../constants/colors';

const MyProceedings = () => {
    //Inicializo el history
    const history = useHistory();
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store
    const authLoading = useSelector(state => state.auth.loading );
    const authProceedings = useSelector(state => state.auth.proceedings );
    const procLoading = useSelector(state => state.proceeding.loading );
    //Inicializo el state local
    const [textFilter, setTextFilter] = useState('');
     //Manejo la selección de expediente
     const handleSelect = proceeding => {
         //Armo los datos
         const data = {
             jurisdiction_id: proceeding.jurisdiction_id,
             procid: proceeding.procid,
             nro_expediente: proceeding.number,
             jurisdiction_slug: proceeding.jurisdiction.toLowerCase().replace(' ', '-')
         }
        //Llamo al disppatch
        dispatch( listHistoryAction(data, history) );
    }
    //Eliminar de mis causas
    const handleRemove = proceeding => {
        alertMessages.confirm({
            title: messages.ACTIONS.REMOVE_PROCEEDING,
            text: messages.NOT_REVERSIBLE,
            confirmColor: colors.blue,
            confirmText: es.ACCEPT,
            callback: () => {
                //Llamo al dispatch
                dispatch( removeProceedingAction(proceeding) )
            }
        });
    }
    //Manejo los cambios del filtro
    const handleChange = e => {
        setTextFilter(e.target.value);
    }
    //Render
    return (
        <Spinner active={authLoading || procLoading}>
            <Layout 
                title={es.MY_PROCEEDINGS} 
                subtitle={es.LIST}
                items={[
                    {
                        title: es.MY_PROCEEDINGS
                    }
                ]}
            >
                <Col md={3} className="mb-2">
                    <Form.Control
                        placeholder={ messages.SEARCH_BY_COVER }
                        value={textFilter}
                        onChange={handleChange}
                        autoFocus
                    />
                </Col>
                <Col xs={12}>
                    <Table striped hover size="sm">
                        <thead className="thead-dark">
                            <tr>
                                <th>{ es.FIELDS.JURISDICTION }</th>
                                <th>{ es.FIELDS.UNIT }</th>
                                <th>{ es.FIELDS.EXPTE }</th>
                                <th>{ es.FIELDS.COVER }</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                authProceedings ? (
                                    authProceedings.filter(proceeding => {
                                        //Verifico texto
                                        if(textFilter.trim() !== ''){
                                            //Filtro por carátula
                                            return proceeding.cover.toUpperCase().indexOf(textFilter.toUpperCase()) !== -1 || proceeding.number.toUpperCase().indexOf(textFilter.toUpperCase()) !== -1 || proceeding.unit.toUpperCase().indexOf(textFilter.toUpperCase()) !== -1;
                                        }
                                        //Retorno
                                        return true;
                                    }).map(proceeding => (
                                        <tr key={`plp${proceeding.id}`}>
                                            <td className="align-middle">
                                                <small>{ proceeding.jurisdiction }</small>
                                            </td>
                                            <td className="align-middle">
                                                <small>{ proceeding.unit }</small>
                                            </td>
                                            <td className="align-middle text-center">
                                                <small>{ proceeding.number }</small>
                                            </td>
                                            <td className="align-middle">
                                                <small>{ proceeding.cover }</small>
                                            </td>
                                            <td className="align-middle text-center">
                                                <OverlayTrigger
                                                    key={`myp-${proceeding.procid}`}
                                                    placement="left"
                                                    overlay={
                                                        <Tooltip id={`tooltipMyProc-${proceeding.procid}`}>
                                                            { es.VIEW_HISTORY.toUpperCase() }
                                                        </Tooltip>
                                                    }
                                                >
                                                    <Button variant="primary" size="sm" onClick={() => handleSelect(proceeding)}>
                                                        <FontAwesomeIcon icon={faLocationArrow} />
                                                    </Button>
                                                </OverlayTrigger>
    
                                                <OverlayTrigger
                                                    key={`myr-${proceeding.procid}`}
                                                    placement="left"
                                                    overlay={
                                                        <Tooltip id={`tooltipMyRemove-${proceeding.procid}`}>
                                                            { es.REMOVE.toUpperCase() }
                                                        </Tooltip>
                                                    }
                                                >
                                                    <Button variant="danger" size="sm" className="ml-2" onClick={() => handleRemove(proceeding)}>
                                                        <FontAwesomeIcon icon={faEraser} />
                                                    </Button>
                                                </OverlayTrigger>
                                            </td>
                                        </tr>
                                    ))
                                ) : null
                            }
                        </tbody>
                    </Table>
                </Col>
            </Layout>
        </Spinner>
    );
};

export default MyProceedings;